// extracted by mini-css-extract-plugin
export default {"winningWrapper":"Winnings_winningWrapper--OHP","winningAmountBlock":"Winnings_winningAmountBlock--C7v","winningCurrency":"Winnings_winningCurrency--Sik"};